import { useState } from "react";

import clsx from "clsx";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { PrimaryButton, SecondaryButton } from "@components/v2/buttons";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { Modal } from "@shared/modal";
import { TextInput } from "@shared/text-input";

export interface CreatedSavedViewModalProps {
  readonly isOpen: boolean;
  onClose: () => void;
  readonly onSubmit: (name: string) => void;
  readonly description?: string;
  readonly title?: string;
  readonly submitText?: string;
  readonly cancelText?: string;
}

export const CreateSavedViewModal = ({
  onSubmit,
  description,
  cancelText = "No, Cancel",
  submitText = "Yes, Save",
  title = "Save as new?",
  ...props
}: CreatedSavedViewModalProps) => {
  const prettyLogEventPage = usePrettyLogEventPage();

  const [name, setName] = useState("");
  const {
    saveViewsSavingState: { isCreating },
  } = useOverviewContext();

  // TODO: Use a more traditional form in this component, and leverage react-hook-form.
  return (
    <Modal
      isOpen={props.isOpen}
      onClose={() => {
        props.onClose();
        setName("");
      }}
      headerTitleProps={{ className: "text-xl font-semibold" }}
      titleContent={<div>{title}</div>}
    >
      {description && (
        <p className="text-sm mb-0 text-[#717680]">{description}</p>
      )}
      <TextInput
        label="SAVED VIEW NAME"
        inputClassName={clsx(
          "focus:ring-cosmic focus:outline-none",
          "focus:border-cosmic focus:ring-1 focus:ring-inset",
        )}
        onChange={({ target }) => setName(target.value)}
        value={name}
      />
      <div className="flex items-center gap-2 mt-8">
        <PrimaryButton
          className="uppercase"
          disabled={!name}
          loading={isCreating}
          onClick={() => {
            prettyLogEventPage({
              domain: "Saved Views",
              action: "onChange",
              additionalActionInfo: "Create Saved View",
              data: {
                pageContext: { name: name },
              },
            });
            if (name) {
              onSubmit(name);
            }
            setName("");
          }}
        >
          {submitText}
        </PrimaryButton>
        <SecondaryButton
          className="uppercase"
          disabled={isCreating}
          onClick={props.onClose}
        >
          {cancelText}
        </SecondaryButton>
      </div>
    </Modal>
  );
};
